import gsap from "gsap";

export class RegularBanner {
  constructor(el) {
    this.DOM = {
      el: el,
      isAutoplay: false,
      autoplay_speed: "",
    };

    this.init();
  }

  init() {
    const bannerEl = this.DOM.el;

    const videoControl = () => {
      bannerEl.querySelectorAll("video").forEach((item) => {
        const flag = item.getAttribute("data-play");
        if (flag === "false" || flag === null) {
          if (window.Jackery.Utils.isElementInViewport(item)) {
            item.play();
            item.setAttribute("data-play", "true");
          }
        } else {
          if (window.Jackery.Utils.isElementOutOfViewport(item)) {
            item.pause();
            item.setAttribute("data-play", "false");
          }
        }
      });
    };

    videoControl();

    window.addEventListener("scroll", () => {
      videoControl();
    });

    const bannerSelector = "." + bannerEl.className.replaceAll(" ", ".");
    $(document).on("click", bannerSelector + " a[data-btn-to-login='true']", function(e) {
      e.preventDefault();
      e.stopPropagation();
      window.jackeryLoginApp && window.jackeryLoginApp.modalLogin({
        return_url: window.location.href,
        "register_act": "Account-Register"
      });
    });

    bannerEl.querySelectorAll(".icon-refresh").forEach((item) => {
      item.addEventListener("click", () => {
        let currVideoDOM = item.nextElementSibling;
        if (document.documentElement.clientWidth < 1024) {
          currVideoDOM = item.nextElementSibling?.nextElementSibling;
        }
        if (currVideoDOM) {
          currVideoDOM.currentTime = 0;
          currVideoDOM.setAttribute("data-play", "true");
          currVideoDOM.play();
        }
      });
    });

    const interleaveOffset = 0.5;
    const _autoplay = bannerEl.getAttribute("data-autoplay") === "true";
    const _speed = Number(bannerEl.getAttribute("data-delay")) || 5;
    let isTouch = true;
    this.DOM.isAutoplay = _autoplay;
    this.DOM.autoplay_speed = _speed;

    const swiperlength = bannerEl.querySelectorAll(".swiper-slide").length;

    if (swiperlength === 1) {
      bannerEl.querySelector(".swiper-wrapper")?.classList.add("disabled");
      bannerEl.querySelector(".slideshow-pagination")?.classList.add("disabled");
      bannerEl.querySelector(".slideshow-pagination")?.style.setProperty("display", "none");
      bannerEl.querySelector(".swiper-arrow")?.style.setProperty("display", "none");
      isTouch = false;
    }

    const animateSlideContent = (swiper) => {
      const activeSlide = swiper.slides[swiper.activeIndex];
      if (activeSlide) {
        const contents = activeSlide.querySelectorAll(".regular-animate");
        contents.forEach((content, index) => {
          setTimeout(() => {
            content.classList.add("active");
          }, index * 100);
        });
      }
    };

    const resetSlideContent = (swiper) => {
      swiper.slides.forEach((slide) => {
        slide.querySelectorAll(".regular-animate").forEach((content) => {
          content.classList.remove("active");
        });
      });
    };

    const container = bannerEl.querySelector(".swiper-container");

    if (!container) return;

    if (swiperlength === 1) {
      const contents = bannerEl.querySelectorAll(".regular-animate");
      contents.forEach((content, index) => {
        setTimeout(() => {
          content.classList.add("active");
        }, index * 100);
      });
      return
    }

    this.swiperGsap = new Swiper(container, {
      simulateTouch: false,
      followFinger: false,
      autoplay: _autoplay
        ? {
            delay: _speed * 1000,
            disableOnInteraction: false,
            reverseDirection: false,
          }
        : false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      speed: 500,
      keyboard: true,
      loop: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      preloadImages: true,
      updateOnImagesReady: true,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: bannerEl.querySelector(".swiper-button-next"),
        prevEl: bannerEl.querySelector(".swiper-button-prev"),
      },
      allowTouchMove: isTouch ? true : false,
      pagination: {
        el: bannerEl.querySelector(".slideshow-pagination"),
        clickable: true,
        bulletClass: "slideshow-pagination-item",
        bulletActiveClass: "active pagination-active",
        clickableClass: "slideshow-pagination-clickable",
        modifierClass: "slideshow-pagination-",
        renderBullet: function (index, className) {
          const number = index <= 8 ? "0" + (index + 1) : index + 1;
          let paginationItem = `<span class="slideshow-pagination-item">`;
          if (index <= 8) {
            paginationItem += `<span class="pagination-separator"><span class="pagination-separator-loader"></span></span>`;
          }
          paginationItem += "</span>";
          return paginationItem;
        },
      },
      on: {
        init() {
          animateSlideContent(this);
        },
        slideChangeTransitionStart() {
          resetSlideContent(this);
        },
        progress(swiper) {
          swiper.slides.forEach((slide) => {
            const slideProgress = slide.progress;
            const innerOffset = swiper.width * interleaveOffset;
            const innerTranslate = slideProgress * innerOffset;
            slide.querySelector(".slide-inner").style.transform = `translate3d(${innerTranslate}px, 0, 0)`;
          });
        },
        touchStart(swiper) {
          swiper.slides.forEach((slide) => {
            slide.style.transition = "";
          });
        },
        setTransition(swiper, speed) {
          swiper.slides.forEach((slide) => {
            slide.style.transition = `${speed}ms`;
            slide.querySelector(".slide-inner").style.transition = `${speed}ms`;
          });
        },
        slideChangeTransitionEnd() {
          animateSlideContent(this);
          const curSlide = Array.from(this.slides).find((it) =>
            it.classList.contains("swiper-slide-active")
          );
          const curImg = curSlide?.querySelector("img");
          if (curImg) {
            curImg.classList.remove("lazyloading");
            curImg.classList.add("lazyloaded");
          }
        },
        resize() {
          setTimeout(() => {
            this.update();
          }, 500);
        },
      },
    });

    if (!bannerEl.querySelector(".swiper-wrapper .slide-inner")) return;

    this.initEvents();
  }

  initEvents() {
    this.swiperGsap.on("paginationUpdate", (swiper, paginationEl) =>
      setTimeout(() => {
        this.pageAnimatePagination(swiper, paginationEl);
      }, 20)
    );

    this.pageAnimatePagination();
  }

  pageAnimatePagination(swiper, paginationEl) {
    if (this.DOM.isAutoplay) {
      const DOC = paginationEl || this.DOM.el.querySelector(".slideshow-pagination");
      const paginationItemsLoader = DOC.querySelectorAll(".pagination-separator-loader");
      const activePaginationItem = DOC.querySelector(".pagination-active");
      const activePaginationItemLoader = activePaginationItem?.querySelector(
        ".pagination-separator-loader"
      );

      gsap.set(paginationItemsLoader, {
        scaleX: 0,
      });

      gsap.to(activePaginationItemLoader, {
        scaleX: 1,
        ease: "linear",
        duration: this.DOM.autoplay_speed,
      });
    }
  }
}
